
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_cqcqk_4gnic_99",
  "wrapper": "awsui_wrapper_cqcqk_4gnic_103",
  "elementWrapper": "awsui_elementWrapper_cqcqk_4gnic_107",
  "markerWrapper": "awsui_markerWrapper_cqcqk_4gnic_111",
  "placement-right": "awsui_placement-right_cqcqk_4gnic_116",
  "placement-left": "awsui_placement-left_cqcqk_4gnic_121",
  "inlineWrapper": "awsui_inlineWrapper_cqcqk_4gnic_126"
};
  